<template>
  <div>
    <div v-if="loading" class="section section--lg section--center section--white-on-color mt-4">
      <div class="req-message-container" style="min-height: 192px;">
        <b-skeleton animation="throb" width="70%"></b-skeleton>
        <br/>
        <b-skeleton animation="throb" width="85%"></b-skeleton>
        <b-skeleton animation="throb" width="55%"></b-skeleton>
        <b-skeleton animation="throb" width="70%"></b-skeleton>
        <b-skeleton animation="throb" width="55%"></b-skeleton>
      </div>
    </div>

    <div v-if="!loading">
      <div v-if="success" class="section section--lg section--center section--white-on-color mt-4">
        <div class="req-message-container">
          <h1 class="req-message-title">{{ $gettext('Unsubscribed from email notifications') }}</h1>
          <p>
            {{ $gettext('You have now been unsubscribed from all Gekko emails. You can subscribe again by changing your') }}
            <a :href="'/comm/notifications/'" style="color: #1F618D;">
              {{ $gettext('notification settings') }}
            </a>
            {{ $gettext('in your account. If you still receive emails or have any questions about this, please contact support@getgekko.com.') }}
          </p>
        </div>
      </div>

      <div v-if="!success" class="section section--lg section--center section--white-on-color mt-4">
        <div class="req-message-container">
          <h1 class="req-message-title text-danger">{{ $gettext('We could not unsubscribe you from email notifications') }}</h1>
          <p>
            {{ $gettext('Something went wrong while unsubscribing you from email notifications. Please try again from ') }}
            <a :href="'/comm/notifications/'" style="color: #1F618D;">
              {{ $gettext('notification settings') }}
            </a>
            {{ $gettext(' or contact support@getgekko.com if the issue persists.') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/store/services/user.service"

export default {
  name: 'UnsubscribeEmail',
  data() {
    return {
      loading: true,
      success: false
    }
  },
  created() {
    let token = this.$route.params['token']

    UserService.unsubscribeViaEmail(token).then(() => {
      this.success = true
    }).finally(() => {
      this.loading = false
    })
  }
}
</script>

<style scoped>
.req-message-container {
  padding: 24px;
  font-size: 23px;
  background-color: #ffffff;
  border: 1px solid #d4d4d4;
  border-radius: 12px;
}

.req-message-title {
  font-size: 41px;
  font-weight: bold;
}
</style>